import { Grid, pn, useElementBreakpoints } from "@compass/core";
import { Select } from "components";
import { StudentApplicationFilter as StudentApplicationFilterModel, StudentFileCategorizedFilter, StudentFileCategorizedListFilter, StudentFileFilterResource } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const StudentFileFilter = (props: {
  filter: StudentFileCategorizedFilter;
  setFilter: (value: StudentFileCategorizedFilter) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints, largeFieldBreakpoints } = useElementBreakpoints();
  const [resource, setResource] = useState<StudentFileFilterResource>({});
  const properties = resource.properties || [];

  useEffect(() => {
    ApiService.studentFiles.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  const fileCategoryField = () => {
    const propertyName = pn<StudentFileCategorizedFilter>("fileCategoryIds");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <Select
        multiple
        modelProperty={property}
        value={resource.fileCategories?.filter((x) => props.filter.fileCategoryIds?.includes(x.id))}
        options={resource.fileCategories}
        getOptionLabel={(option) => option.name}
        onChange={(e, values) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.fileCategoryIds = values.map((x) => x.id);
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={largeFieldBreakpoints}>
        {fileCategoryField()}
      </Grid>
    </Grid>
  );
};
